import { getMarketingBrandSlug } from '~spa/SpectateConfig';

export const is888MarketingBrand = () => getMarketingBrandSlug() === '888';
export const isSiMarketingBrand = () => getMarketingBrandSlug() === 'si';
export const isMrgMarketingBrand = () => getMarketingBrandSlug() === 'mrg';
